import React from 'react'
import { IReport, IReportData } from '../../helpers/Interfaces'
import { convertDuration, splitWord, validDateField, validStringField } from '../../helpers/HelperFunctions'

type DocumentDetailsProps = {
    selectedDocument: IReport,
    report: IReportData
}

function DocumentDetails(props: Readonly<DocumentDetailsProps>) {
    return (
        <div className='view-document-body document-details'>
            <DocumentDataView title={'Patient Name'}
                detail={validStringField(props.selectedDocument.patientName)} />
            <DocumentDataView title={'Doctor'}
                detail={validStringField(props.selectedDocument.doctor)} />
            <DocumentDataView title={'Clinic'}
                detail={validStringField(props.selectedDocument.clinic)} />
            <DocumentDataView title={'Report Type'}
                detail={validStringField(props.selectedDocument.reportType)} />
            <DocumentDataView title={'Referrer'}
                detail={validStringField(props.selectedDocument.referrer)} />
            <DocumentDataView title={'Created Date'}
                detail={validDateField(props.selectedDocument.createdDate)} />
            <DocumentDataView title={'Date of Assessment'}
                detail={validDateField(props.selectedDocument.dateOfAssessment)} />
            <DocumentDataView title={'Place of Assessment'}
                detail={validStringField(props.selectedDocument.placeOfAssessment)} />
            <DocumentDataView title={'Due Date'}
                detail={validDateField(props.selectedDocument.dueDate)} />
            <DocumentDataView title={'Priority'}
                detail={validStringField(props.selectedDocument.priority)} />
            <DocumentDataView title={'Provider Number'}
                detail={validStringField(props.selectedDocument.providerNumber)} />
            <DocumentDataView title={'Submitted Date'}
                detail={validDateField(props.selectedDocument.submittedDate)} />
            <DocumentDataView title={'Completed Date'}
                detail={validDateField(props.selectedDocument.completedDate)} />
            <DocumentDataView title={'Duration'}
                detail={convertDuration(props.selectedDocument.totalDuration)} />
            {props.selectedDocument.paperworkReceived !== null
                ? (<DocumentDataView title={'Paperwork Received'}
                    detail={validStringField(props.selectedDocument.paperworkReceived ? "Yes" : "No")} />)
                : (<></>)
            }
            {props.selectedDocument.invoiceStatus !== null
                ? (<DocumentDataView title={'Invoice'}
                    detail={validStringField(splitWord(props.selectedDocument.invoiceStatus))} />)
                : (<></>)
            }
            <div className="comment-view">
                <DocumentDataView title={'Comments'}
                    comment={validStringField(props.selectedDocument.notes)} />
            </div>
        </div>
    )
}

function DocumentDataView(props: { title: string, detail?: any, comment?: any }) {
    return (
        <div className="document-detail-view">
            <div className="detail-header">{props.title}</div>
            <div className="detail-value">{props.detail}</div>
            <div className='detail-value' style={{ whiteSpace: "pre-wrap" }}>{renderTextWithLinks(props.comment)}</div>
        </div>
    );
}

function renderTextWithLinks(text: string) {
    if (typeof text !== 'string') return text;

    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex);

    return parts.map((part, index) => {
        if (part.match(urlRegex)) {
            return (
                <a key={index} href={part} target="_blank" rel="noopener noreferrer" className="detail-link">
                    {part}
                </a>
            );
        }
        return part;
    });
}

export default DocumentDetails